import * as React from "react";
import PropTypes from "prop-types";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useTranslation } from "react-i18next";

function Header(props) {
  const { sections, title } = props;
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "zh" : "en";
    i18n.changeLanguage(newLang);
  };

  const handleSignIn = () => {
    navigate("/signin");
  };

  const handleSignOut = () => {
    logout();
    navigate("/");
  };

  return (
    <React.Fragment>
      <Toolbar sx={{ borderBottom: 1, borderColor: "divider" }}>
        {/* <Button size="small">Subscribe</Button> */}
        <Typography
          component="h2"
          variant="h5"
          color="inherit"
          align="center"
          noWrap
          sx={{ flex: 1 }}
        >
          {title}
        </Typography>
        <IconButton>
          <SearchIcon />
        </IconButton>
        {isAuthenticated ? (
          <Button variant="outlined" size="small" onClick={handleSignOut}>
            {t("signOut")}
          </Button>
        ) : (
          <Button variant="outlined" size="small" onClick={handleSignIn}>
            {t("signIn")}
          </Button>
        )}
        <Button onClick={toggleLanguage}>
          {i18n.language === "en" ? "中文" : "English"}
        </Button>
      </Toolbar>
      <Toolbar
        component="nav"
        variant="dense"
        sx={{
          justifyContent: "flex-start",
          overflowX: "auto",
          gap: 3, // space between menu items
          px: 2,
        }}
      >
        {sections.map((section) => (
          <Link
            key={section.title}
            href={section.url}
            variant="body1"
            underline="none"
            color="text.primary"
            sx={{
              fontWeight: 500,
              fontSize: "1rem",
              "&:hover": {
                color: "primary.main",
                textDecoration: "underline",
              },
              transition: "color 0.2s ease",
            }}
          >
            {section.title}
          </Link>
        ))}
      </Toolbar>
    </React.Fragment>
  );
}

Header.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
};

export default Header;
